import styled, { css } from "@digits-css"
import colors from "@digits-shared/themes/colors"
import { m } from "framer-motion"
import "./background.digits.css"

export const DIGITS_BACKGROUND_LAYERS = `fixed radial-gradient(ellipse at 38% 45%, rgba(222, 227, 223, 1) 0%, rgba(220, 226, 223, 0) 90%)
      no-repeat,
    linear-gradient(135deg, #a5cbe7, #9db9f0) repeat`

export const DIGITS_BACKGROUND = css`
  background: ${DIGITS_BACKGROUND_LAYERS};
  background-size: cover;
`

export const DigitsEditBackground = styled(m.div)({ cls: "background__DigitsEditBackground_8f5f32f", vars: { "--background__DigitsEditBackground_8f5f32f-p0": ({ backgroundUrl }) => `url(${backgroundUrl})` } })
